import React from 'react';
import { useTranslation } from '../../shared/i18n';
import { Footer } from '../../shared/components';
import {
  HeroSection,
  PriceSection,
  IncludesSection,
  HowToPlaySection,
  ImageGallery,
  FAQSection,
} from './components';
import useProductPage from './hooks/useProductPage';

// Images
import conecta2Box from '../../assets/conectados/box.gif';
import productImage10 from '../../assets/conectados/producto/producto-10.webp';
import productImage2 from '../../assets/conectados/producto/producto-2.webp';
import productImage3 from '../../assets/conectados/producto/producto-3.webp';
import productImage4 from '../../assets/conectados/producto/producto-4.webp';
import productImage5 from '../../assets/conectados/producto/producto-5.webp';
import productImage6 from '../../assets/conectados/producto/producto-6.webp';
import productImage8 from '../../assets/conectados/producto/producto-8.webp';
import productImage9 from '../../assets/conectados/producto/producto-9.webp';

import * as S from './Conecta2ProductPage.styles';

const Conecta2ProductPage = () => {
  const t = useTranslation();
  const {
    selectedPayment,
    handlePaymentSelect,
    onClickWhatsApp,
    getWhatsappMessage,
    getPaymentInfoMessage,
  } = useProductPage();

  const galleryImages = t('conecta2Product.gallery.images');
  const productImages = [
    { src: productImage10, alt: galleryImages[0].alt },
    { src: productImage2, alt: galleryImages[1].alt },
    { src: productImage3, alt: galleryImages[2].alt },
    { src: productImage4, alt: galleryImages[3].alt },
    { src: productImage5, alt: galleryImages[4].alt },
    { src: productImage6, alt: galleryImages[5].alt },
    { src: productImage8, alt: galleryImages[7].alt },
    { src: productImage9, alt: galleryImages[8].alt },
  ];

  return (
    <S.PageContainer>
      <HeroSection
        image={conecta2Box}
        imageAlt={t('conecta2Product.hero.imageAlt')}
      />

      <PriceSection
        selectedPayment={selectedPayment}
        onPaymentSelect={handlePaymentSelect}
        onClickWhatsApp={onClickWhatsApp}
        whatsAppMessage={getWhatsappMessage()}
        paymentInfoMessage={getPaymentInfoMessage()}
      />

      <IncludesSection />

      <HowToPlaySection />

      <ImageGallery images={productImages} />

      <FAQSection />

      <Footer />
    </S.PageContainer>
  );
};

export default Conecta2ProductPage;
